module.exports = __webpack_public_path__ + "images/0d249b97844ffd362aa3bdb719bffba1.svg";